import React, { useState, useEffect } from 'react'
import {
  View,
  Platform,
  KeyboardAvoidingView,
  StyleSheet,
  TouchableOpacity,
  Image,
  Text
} from 'react-native'
import {
  Bubble,
  GiftedChat,
  BubbleProps,
  IMessage,
  Send,
  InputToolbar
} from 'react-native-gifted-chat'

import { Entypo, Ionicons } from '@expo/vector-icons'

import { colorPalette, globalStyles } from '../../static/styles/global'

const ChatScreen = ({ navigation }) => {
  const [messages, setMessages] = useState([])

  const onSend = (newMessages = []) => {
    setMessages((prevMessages) => GiftedChat.append(prevMessages, newMessages))
  }
  useEffect(() => {
    setMessages([
      {
        _id: 1,
        text: 'Hello developer',
        createdAt: new Date(),
        user: {
          _id: 2,
          name: 'React Native'
        }
      }
    ])
  }, [])

  const CustomSendButton = (props) => {
    return (
      <Send {...props}>
        <View style={styles.sendButton}>
          <Entypo
            name="direction"
            size={24}
            style={{ position: 'absolute', right: 20, top: 10 }}
          />
        </View>
      </Send>
    )
  }

  const renderBubble = (props: Readonly<BubbleProps<IMessage>>) => {
    return (
      <Bubble
        {...props}
        wrapperStyle={{
          left: {
            backgroundColor: '#EAF2F5'
          },
          right: {
            backgroundColor: '#EFEFEF'
          }
        }}
        textStyle={{
          right: {
            color: 'black'
          }
        }}
        timeTextStyle={{
          right: {
            color: 'black' // Change the color of the time text on the right side
          }
        }}
      />
    )
  }

  return (
    <View style={styles.container}>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View
          style={[
            globalStyles.hDirection,
            globalStyles.vCenterItems,
            globalStyles.hBetweenItems,
            globalStyles.mb3
          ]}
        >
          <TouchableOpacity
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.flexOne
            ]}
            onPress={() => {
              navigation.navigate('Department Messages')
            }}
          >
            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
              <Ionicons
                name="chevron-back"
                size={24}
                color={colorPalette.white}
              />
            </View>

            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              {'Department Messages'}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{ marginTop: 20 }}>
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 24
            }}
          >
            Question about w2
          </Text>
        </View>
      </View>
      <GiftedChat
        messages={messages}
        onSend={(newMessages) => onSend(newMessages)}
        user={{
          _id: 1
        }}
        renderBubble={renderBubble} //for box color
        alwaysShowSend // for always showing send symbol
        renderSend={(props) => <CustomSendButton {...props} />}
        renderAvatar={() => null}
      />
      {Platform.OS === 'android' && <KeyboardAvoidingView behavior="padding" />}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white'
  },
  sendButton: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 44,
    height: 44,
    borderRadius: 22,
    marginRight: 4,
    marginBottom: 4
  }
})

export default ChatScreen
